var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    fillOpacity: 0.5,
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    fillOpacity: 0.8,
    d: "M0 0h6v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "svg-path3",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 19H25l-2-2h-8v16h20V19zm-1.25 12.75h-17.5v-11.5h17.5v11.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.00e80521a2937e4e315da3de058fde12.svg";
export { ForwardRef as ReactComponent };